import cx from 'classnames';
import styles from '../ConditionalTile.module.scss';

type OwnProps = {
  heading1?: string;
  heading2?: string;
  isMobile?: boolean;
  light?: boolean;
};

export default function CTContentTitle({
  isMobile = false,
  light,
  heading1 = '',
  heading2 = ''
}: OwnProps) {
  const getTitle = () => {
    if (heading2 !== '') {
      return (
        <>
          {heading1}
          <br></br>
          {heading2}
        </>
      );
    }

    return heading1;
  };

  const title = getTitle();

  return (
    <div
      className={cx(
        styles.ctContentTitle,
        'flex flex-col items-center justify-center mb-4',
        {
          light,
          mobile: isMobile
        }
      )}
    >
      {title}
    </div>
  );
}
